import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../Shared/API/config';
import {
  LoginFormData,
  LoginResponse,
  OtpRequestData,
  OtpResponse,
  PasswordRequestData,
  SendOtpRequest,
  SendOtpResponse,
} from '../Shared/types/auth';

export const authSlice = createApi({
  reducerPath: 'auth',
  baseQuery,
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, LoginFormData>({
      query: data => ({
        url: '/2fa/login',
        method: 'POST',
        body: data,
      }),
    }),
    sendOtp: builder.mutation<SendOtpResponse, SendOtpRequest>({
      query: data => ({
        url: '/2fa/login/otp/send',
        method: 'POST',
        body: data,
      }),
    }),
    verifyOtp: builder.mutation<OtpResponse, OtpRequestData>({
      query: data => ({
        url: '/2fa/confirm/otp',
        method: 'POST',
        body: data,
      }),
    }),
    changePassword: builder.mutation<OtpResponse, PasswordRequestData>({
      query: data => ({
        url: '/2fa/change-password',
        method: 'POST',
        body: data,
      }),
    }),
    getTemporaryToken: builder.query<any, void>({
      query: () => ({
        url: '/reports/v2/token',
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useSendOtpMutation,
  useVerifyOtpMutation,
  useChangePasswordMutation,
  useGetTemporaryTokenQuery,
  useLazyGetTemporaryTokenQuery,
} = authSlice;
